// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.recipient-mode[data-v-d4e29e48] {\n\tmargin-top: 8px;\n}\n.recipient-mode-description[data-v-d4e29e48] {\n\tmargin: 2px 0 0 28px;\n\tfont-size: 0.85em;\n\topacity: 0.7;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
